import { API_URL, API_USER_URL } from "@/env";
import { message } from "antd";
import { ListUserAPI, SearchReferralAPI, UserAPI } from "./type";


const API_USE = API_USER_URL || '';

function getUserIdFromLocalStorage() {
    const userData = localStorage.getItem('user');
    if (userData) {
        const user = JSON.parse(userData);
        return user.id;
    }
    return null;
}

async function fetchAllUser(page: number, limit: number, program?: string): Promise<ListUserAPI> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }

    try {
        const response = await fetch(`${API_USE}/api/v1/be/users?page=${page}&limit=${limit}${program ? `&program=${program}` : ''}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        });
        if (!response.ok) {
            throw new Error(`Error fetching user data: ${response.statusText}`);
        }
        const data = await response.json();
        return data as ListUserAPI;
    } catch (error) {
        console.error('Failed to fetch user data:', error);
        throw error;
    }
}

async function fetchUserData(userId?: string): Promise<UserAPI> {
    const token = localStorage.getItem('token') || '';
    if (!userId) {
        const id = getUserIdFromLocalStorage();
        if (id) {
            userId = id.toString();
        } else {
            message.error('Người dùng không hợp lệ!');
            throw new Error('Invalid user');
        }
    }
    if (!token) {
        throw new Error('No authentication token found');
    }

    try {
        const response = await fetch(`${API_USE}/api/v1/be/users/${userId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        });
        if (!response.ok) {
            message.error('Error fetching user data');
            throw new Error(`Error fetching user data: ${response.statusText}`);
        }
        const data = await response.json();
        return data.data as UserAPI;
    } catch (error) {
        console.error('Failed to fetch user data:', error);
        throw error;
    }
}

async function updateUserProfile(data: any): Promise<UserAPI | undefined> {
    const userId = getUserIdFromLocalStorage();
    if (!userId) {
        message.error('Người dùng không hợp lệ!');
        return;
    }
    const token = localStorage.getItem('token') || '';
    if (!token) {
        message.error('No authentication token found');
        return;
    }
    const response = await fetch(API_USE + `/api/v1/be/users/${userId}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(data),
    });

    const resData = await response.json();

    if (resData.status === false || !response.ok) {
        message.error('Cập nhật thất bại!');
    }
    else {
        localStorage.setItem('user', JSON.stringify(resData.data));
        message.success('Cập nhật thành công!');
    }
    return resData.data;
}


async function getCurrentUser(): Promise<UserAPI | null> {
    const userId = getUserIdFromLocalStorage();
    const token = localStorage.getItem('token') || '';
    if (!userId || !token) {
        message.error('Người dùng không hợp lệ!');
        return null;
    }
    if (userId) {
        try {
            const userData = await fetchUserData(userId.toString());
            return userData;
        } catch (error) {
            console.error('Error getting current user:', error);
            return null;
        }
    }
    return null;
}

async function requestOTPChangePassword(): Promise<void> {
    const userId = getUserIdFromLocalStorage();
    const token = localStorage.getItem('token') || '';
    if (!userId || !token) {
        message.error('Người dùng không hợp lệ!');
        return;
    }

    try {
        const response = await fetch(`${API_USE}/api/v1/be/users/request-change-otp`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        });
        const data = await response.json();
        if (data.status) {
            message.success('OTP sent successfully! Please check your email.');
        } else {
            message.error(data.message || 'Failed to send OTP, please try again!');
        }
    } catch (error) {
        console.error('Failed to request OTP for change password:', error);
        message.error('Failed to send OTP, please try again!');
    }
}

async function requestChangePassword(oldPassword: string, newPassword: string, confirmPassword: string, otp: string): Promise<void> {
    const userId = getUserIdFromLocalStorage();
    const token = localStorage.getItem('token') || '';
    if (!userId || !token) {
        message.error('Người dùng không hợp lệ!');
        return;
    }
    try {
        const response = await fetch(`${API_USE}/api/v1/be/users/change-password`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify({
                current_password: oldPassword,
                new_password: newPassword,
                new_password_confirmation: confirmPassword,
                otp: otp
            }),
        });
        const data = await response.json();
        if (data.status) {
            message.success('Password changed successfully!');
            return data.status;
        } else {
            message.error(data.message || 'Failed to change password, please try again!');
            return data.status;
        }
    } catch (error) {
        console.error('Failed to change password:', error);
        message.error('Failed to change password, please try again!');
        return Promise.reject(error);
    }
}

async function searchReferral(keyword: string): Promise<SearchReferralAPI | undefined> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }
    try {
        const response = await fetch(`${API_URL}/api/v1/be/referral/get-code?keyword=${encodeURIComponent(keyword)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'X-Internal-Secret': "mcdm6G/lr4llf7CR+QaxtI3e2LHyFZCU2wAopmAye2A="
            },
        });
        if (!response.ok) {
            throw new Error(`Error searching referral users: ${response.statusText}`);
        }
        const data = await response.json();
        return data as SearchReferralAPI;
    } catch (error) {
        console.error('Failed to search referral users:', error);
        throw error;
    }
}

export {
    fetchAllUser,
    fetchUserData,
    getCurrentUser,
    updateUserProfile,
    requestOTPChangePassword,
    requestChangePassword,
    searchReferral
};